// extracted by mini-css-extract-plugin
export default {"container":"_3cmMNUy7sQiaJ0dIYz6PmZ","inertChildren":"_76EGW2BrLudY2wqigJy6h0","siteShutdownNotice":"_62PEDpTwTz2TxvP8thN6TJ"};